module.exports = __webpack_public_path__ + "static/img/jcoin03.1898980.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jcoin03.png
// module id = iXGB
// module chunks = 1